export default {
  finalize() {
     const $post_types = $('#main-search-post-types');

     $post_types.on('changed.bs.select', function () {
       $post_types.parent().parent().submit();
     });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/search.js